export const addToCartTrackingEvent = value => {
  if (window.uetq) {
    const revenuValue = parseFloat(value);
    window.uetq.push('event', 'add_to_cart', { revenue_value: revenuValue, currency: 'EUR' });
  }
};

export const beginCheckoutTrackingEvent = value => {
  if (window.uetq) {
    const revenuValue = parseFloat(value);
    window.uetq.push('event', 'begin_checkout', { revenue_value: revenuValue, currency: 'EUR' });
  }
};
